import React, { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';

interface PlaidLinkProps {
  linkToken: string | null;
  onSuccess: (publicToken: string, metadata: any) => void;
  onExit: (err: any, metadata: any) => void;
  onLoad?: () => void;
}

const PlaidLink: React.FC<PlaidLinkProps> = ({ 
  linkToken, 
  onSuccess, 
  onExit, 
  onLoad 
}) => {
  const config = {
    token: linkToken,
    onSuccess: (publicToken: string, metadata: any) => {
      // Debug log only in development
      if (process.env.NODE_ENV === 'development') {
        console.log('Plaid Link success:', publicToken, metadata);
      }
      onSuccess(publicToken, metadata);
    },
    onExit: (err: any, metadata: any) => {
      // Debug log only in development
      if (process.env.NODE_ENV === 'development') {
        console.log('Plaid Link exit:', err, metadata);
      }
      onExit(err, metadata);
    },
    onLoad: () => {
      // Debug log only in development
      if (process.env.NODE_ENV === 'development') {
        console.log('Plaid Link loaded');
      }
      onLoad?.();
    },
  };

  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    if (ready && linkToken) {
      // Debug log only in development
      if (process.env.NODE_ENV === 'development') {
        console.log('Opening Plaid Link...');
      }
      open();
    }
  }, [ready, linkToken, open]);

  return null; // This component doesn't render anything visible
};

export default PlaidLink; 